export const strings = {
  AuthOneTimePinButtonText: 'Resend OTP',
  AuthUsernameLabel: 'Email or phone number',
  AuthUsernameError: 'Username should be email or phone number',
  AuthUsernameHeading: 'Welcome back',
  AuthUsernameSubheading: 'Enter your credentials to log in',
  AuthDeliveryMethodHeading: "Please verify it's you",
  AuthDeliveryMethodSubheading: 'Select where we can send your one-time PIN',
  AuthDeliveryMethodButtonText: 'Send One-Time PIN',
  AuthOneTimePinHeading: 'Enter One-time PIN',
  AuthOneTimePinSubheading:
    'A one-time PIN has been sent to the [field] associated with [username]',
  AuthLabelEmail: 'Email',
  AuthLabelSMS: 'SMS',
  AuthLoginText: 'Log in',
  NotLoggedIn: 'Not logged in',
  DateOfBirth: 'Date of birth',
  DateLabel: 'Date',
  DateTimeLabel: 'Date & time',
  Gender: 'Gender',
  LanguagePreference: 'Language preference',
  CardLabelAge: 'Age',
  RiskUnspecified: 'unspecified',
  TitleMr: 'Mr.',
  TitleMrs: 'Mrs.',
  TitleMiss: 'Miss',
  TitleDr: 'Dr.',
  TitleSr: 'Sr.',
  TitleProf: 'Prof.',
  GivenName: 'First name',
  FamilyName: 'Last name',
  RegistrationNumber: 'Registration number',
  Email: 'Email',
  Phone: 'Primary Phone Number',
  LabelPhone: 'Phone',
  Phone2: 'Alternate Phone Number',
  SecondaryPhone: 'Secondary phone numbers',
  Specialty: 'Specialty',
  SouthAfrica: 'South Africa',
  Namibia: 'Namibia',
  DeviceName: 'Device name',
  DisplayError: 'Error loading display name',
  DisplayLoading: 'Loading',
  VitalSignsError: 'Error loading latest vital signs',
  GeneralPractitioners: 'Practitioners',
  OrganizationalPractitioners: 'Group Practitioners',
  Location: 'Virtual ward',
  CardTitleCareTeam: 'Care team',
  DeviceUseStatementPeriodError:
    'Time period cannot be greater than 24hrs - please choose a valid time period.',
  DeviceUseStatementCancelTitle: 'Cancel device association',
  DeviceUseStatementTerminateTitle: 'Terminate device association',
  DeviceUseStatementCancelMessage:
    'Are you sure you want to cancel this device association?',
  DeviceUseStatementTerminateMessage:
    'Are you sure you want to terminate this device association?',
  DeviceUseStatementCancelButton: 'Cancel',
  DeviceUseStatementTerminateButton: 'Terminate',

  DeviceUseStatementStatusEnteredInError: 'Entered In Error',
  DeviceUseStatementStatusActive: 'Active',
  DeviceUseStatementStatusCompleted: 'Completed',
  DeviceUseStatementStatusIntended: 'Intended',
  DeviceUseStatementStatusStopped: 'Stopped',
  DeviceUseStatementStatusOnHold: 'OnHold',

  SOAPNoteCreateTitle: 'New note',
  SOAPNoteTitle: 'Note',
  SOAPNotePreviewTitle: 'Note Preview',
  SOAPNoteAssessmentStable: 'Stable',
  SOAPNoteAssessmentImproving: 'Improving',
  SOAPNoteAssessmentDeteriorating: 'Deteriorating',
  SOAPNoteAssessmentDemised: 'Demised',
  SOAPNotePlanContinue: 'Continue management',
  SOAPNotePlanContinueOnboarding: 'Continue onboarding',
  SOAPNotePlanDeclinedOnboarding: 'Declined onboarding',
  SOAPNotePlanAmend: 'Amend plan',
  SOAPNotePlanDischarge: 'Discharge',
  SOAPNotePlanEscalate: 'Escalate',
  SOAPNotePlanUpgradedToHAH: 'Upgraded to HAH',
  SOAPNoteAdditionalNoteTextTitle: 'Additional subjective note',
  // TODO: get better text for these fields
  SOAPNoteButtonTextCreateNote: 'New note',
  SOAPNoteButtonTextHide: 'Hide',
  SOAPNoteButtonTextEditNote: 'Edit',
  SOAPNoteButtonTextCancel: 'Cancel',
  SOAPSubjectiveTitle: 'Subjective',
  SOAPObjectiveTitle: 'Objective',
  SOAPAssessmentTitle: 'Assessment',
  SOAPPlanTitle: 'Plan',
  SOAPNoteSubjectiveCommentsPlaceholder: 'Subjective comments',
  SOAPNoteObjectiveCommentsPlaceholder: 'Objective comments',
  SOAPNoteAssessmentCommentsPlaceholder: 'Assessment comments',
  SOAPNotePlanCommentsPlaceholder: 'Plan Comments',
  SOAPNoteCodeDescription: 'Visit type',
  SOAPNoteLocationDescription: 'Location',
  SOAPNoteCodeRoutine: 'Routine',
  SOAPNoteCodeClinicalUpdate: 'Clinical update',
  SOAPNoteCodeOnboarding: 'Onboarding',
  SOAPNoteCodeAuthorization: 'Authorization',
  SOAPNoteCodeClinicalCallout: 'Clinical Callout',
  SOAPNoteCodeWelcome: 'Welcome',
  SOAPNoteCodeDischarge: 'Discharge',
  SOAPNoteCodeBloodResults: 'Blood Results',
  SOAPNoteCodePhysiotherapy: 'Physiotherapy',
  SOAPNoteCodeHandover: 'Handover',
  SOAPNoteDailySummary: 'Daily summary',
  SOAPNoteOverallSummary: 'Overall summary',
  SOAPNotePreOnboarding: 'Pre-Onboarding',
  SOAPNoteLocationCodeVirtual: 'Virtual',
  SOAPNoteLocationCodeInPerson: 'In-person',
  SOAPNoteCodeRequiredErrorMessage: 'Note type is required',
  SOAPNoteLocationRequiredErrorMessage: 'Location is required',
  SOAPNoteSubjectiveRequiredErrorMessage: 'Subjective comments are required',
  SOAPNoteObjectiveRequiredErrorMessage: 'Objective comments are required',
  SOAPNoteAssessmentRequiredErrorMessage: 'Assessment comments are required',
  SOAPNoteAllItemsRequiredErrorMessage:
    'Please ensure all SOAP note items are completed',
  SOAPNotePlanRequiredErrorMessage: 'Plan comments are required',
  SOAPNoteSubmissionErrorMessage: 'Error submitting note',
  SOAPNoteSubmissionSuccessMessage: 'Note successfully created',
  SOAPNoteEditSubmissionSuccessMessage: 'Note successfully edited',
  DeleteButtonText: 'Delete',
  DurationSuffixAgo: 'ago',
  FormLabelAttachments: 'Attachments',
  ButtonTextAddAttachment: 'Add attachment',
  FormLabelPractitionersToNotify: 'Notify practitioners',
  ButtonTextLoadMore: 'Load more',
  ListEndOfEntriesText: 'No more items',
  TextBoxPlaceholderSearch: 'Search',
  PlaceholderPractitionerDisplayMissing: 'Name not provided',
  WhatsappChatPatient: 'Patient',
  WhatsappChatNextOfKin: 'Next of kin',
  VideoConsult: 'Video consult',
  JoinMeeting: 'Join Meeting',
  ButtonTextEndConsult: 'End Consult',
  ButtonTextLeaveWaitingRoom: 'Leave Waiting Room',

  MeetingLoadingTitle: 'Loading',
  WaitingRoomTitle: 'Waiting Room',
  Mute: 'Mute',
  Unmute: 'Unmute',
  PatientMedicalAidSearchId: 'SA ID number or medical aid number is required',
  FormLabelPatientDetails: 'Patient details',
  FormLabelPatientContactDetails: 'Patient contact details',
  FormLabelNextOfKin: 'Next of kin details',
  RadioOptionNextOfKinOther: 'Other',
  FormLabelMedicalAid: 'Medical aid',
  FormLabelMedicalAidNumber: 'Medical aid number',
  FormLabelPrivate: 'Private',
  FormLabelScheme: 'Scheme',
  FormLabelIDType: 'ID type',
  FormLabelIsMainMember: 'Is Patient Main Member',
  FormLabelYes: 'Yes',
  FormLabelNo: 'No',
  FormLabelMedicalAidStatus: 'Membership status',
  FormLabelMedicalAidStart: 'Start',
  FormLabelMedicalAidEnd: 'End',
  FormPlaceholderPhonePrimary: 'Primary phone number',
  FormPlaceholderPhoneAlternative: 'Phone alternative (optional)',
  FormPlaceholderAddressLine2: 'Address line 2 (optional)',
  ButtonTextFindPatient: 'Find patient',
  LabelPatientName: 'Patient name',
  ButtonTextOnboardPatient: 'Onboard patient',
  ButtonTextNext: 'Next',
  LabelPrivatePatientOnboardError:
    'Cannot on-board private patient, please try again',
  // TODO: Needs a better naming structure for this strings
  LabelRisk: 'Risk',
  FormTitleSearch: 'Search',
  ButtonTextSearch: 'Search',
  SortFilterAll: 'All',
  SortFilterActive: 'Active',
  SortFilterDischarged: 'Discharged',
  FilterNameAscending: 'Name (A-Z)',
  FilterNameDescending: 'Name (Z-A)',
  FilterSurnameAscending: 'Surname (A-Z)',
  FilterSurnameDescending: 'Surname (Z-A)',
  FilterActive: 'Active',
  TitleFilterBy: 'Filter by',
  FilterInactive: 'Inactive',
  TitleSortBy: 'Sort By',
  LabelStatus: 'Status',
  LabelCaution: 'Caution',
  LabelSort: 'Sort',
  LabelTitle: 'Title',
  LabelName: 'Name',
  LabelSurname: 'Surname',
  LabelIDNumber: 'ID number',
  LabelIDNumberOrMedicalAidNumber: 'ID Number / MedicalAid Number',
  ButtonTextSignOut: 'Sign Out',
  LabelCity: 'City',
  LabelPostalCode: 'Postal code',
  LabelCountry: 'Country',
  LabelSex: 'Sex',
  LabelStreetAddress: 'Street address',
  LabelAddressLine1: 'Address line 1',
  LabelAddressLine2: 'Address line 2',
  LabelInCaseOfEmergency: 'In case of emergency',
  LabelIdentification: 'Identifier',
  LabelIdentifierType: 'ID Type',
  LabelPassportNumber: 'Passport Number',
  LabelSAIDNumber: 'SA ID Number',
  LabelNamibiaIDNumber: 'Namibia ID Number',
  LabelIDorPassportNumber: 'ID or Passport Number',
  LabelPatientId: 'Patient FHIR ID',
  GenderMale: 'Male',
  GenderFemale: 'Female',
  GenderOther: 'Other',
  GenderUnknown: 'Unknown',
  RiskLow: 'Low',
  RiskMedium: 'Medium',
  RiskHigh: 'High',
  LabelAddress: 'Address',
  ButtonTextEdit: 'Edit',
  ButtonTextUpdate: 'Update',
  LabelPersonalDetails: 'Personal details',
  LabelContactDetails: 'Contact details',
  LabelNameAndSurname: 'Name & Surname',
  LabelLocation: 'Current Ward',
  TitleRelayStatus: 'Relay Status',
  LabelRelayStatus: 'Status',
  LabelRelayID: 'Relay ID',
  LabelLastUpdated: 'Last Updated',
  LabelPhoneBattery: 'PhoneBattery',
  LabelPhoneNumber: 'PhoneNumber',
  LabelAvailableStorage: 'Available Storage (MB)',
  LabelBluetoothConnections: 'Bluetooth Connections',
  LabelMBSAppStatus: 'MBS App Status',
  LabelRelayAppVersion: 'Relay App Version',
  LabelMBSAppVersion: 'MBS App Version',
  LabelNetworkQuality: 'Network Quality',
  LabelLastReboot: 'Last Reboot',
  Now: 'Now',
  StartConsult: 'Join Consultation',
  ButtonTextJoinMeeting: 'Join Meeting',
  StartConsultHeader: 'Start Video Consult',
  SendInviteHeader: 'Send Invite',
  CreateConsult: 'Create instant consult',
  MeetingId: 'Meeting ID',
  ErrorJoiningMeeting: 'Error joining meeting, please try again',
  CardLabelMedicalAidDetails: 'Medical aid details',
  CardLabelPatientDetails: 'Patient details',
  CardLabelDependantCode: 'Dependant code',
  CardLabelDependantName: 'Dependant name',
  CardLabelDependantType: 'Dependant type',
  CardLabelMainMemberDetails: 'Main member details',
  CardLabelEffectiveDateFrom: 'Effective date from',
  CardLabelEffectiveDateTo: 'To',
  CardLabelAdministrator: 'Administrator',
  FormLabelAdministrator: 'Administrator',
  CardLabelScheme: 'Scheme',
  CardLabelPlanAndOption: 'Plan and option',
  CardLabelNameAndSurname: 'Name and Surname',
  CardLabelNextOfKin: 'Next of kin',
  LabelNextOfKin: 'Next of kin',
  NextOfKinButtonTextCreate: 'Add NextOfKin',
  ButtonTextRefresh: 'Refresh',
  LabelExpand: 'Expand',
  LabelCollapse: 'Collapse',
  TableColumnCalibrate: 'Calibrate',
  ButtonTextCreatePatient: 'Create Patient',
  PatchCalibrateFormTitle: 'Calibrate Patch',
  PatchCalibrateFormTitleShort: 'Calibrate',
  PatchCalibrateTitleTemperature: 'Temperature',
  PatchCalibrateTitlePosture: 'Posture',
  PostureCalibrationUnknown: 'Unknown',
  PostureCalibrationUpright: 'Upright',
  PostureCalibrationLayingSupine: 'Laying Supine',
  PostureLayingDown: 'Laying Down',
  PostureLayingDownShort: 'Laying',
  PostureLeaningBack: 'Leaning Back',
  PostureLeaningBackShort: 'Leaning',
  PostureNotFound: 'Not Found',
  PostureRunning: 'Running',
  PostureSitting: 'Sitting',
  PostureStanding: 'Standing',
  PostureUnknown: 'Unknown',
  PostureWalking: 'Walking',
  VitalTitleOxygenSaturation: 'Oxygen Saturation',
  VitalTitleCoreTemperature: 'Core Body Temperature',
  VitalTitleSkinTemperature: 'Skin Temperature',
  VitalTitleHeartRate: 'Heart Rate',
  VitalTitleRespiratoryRate: 'Respiratory Rate',
  VitalTitlePosture: 'Posture',
  VitalTitleSteps: 'Activity',
  VitalTitleECG: 'ECG',
  VitalTitlePerfusionIndex: 'Perfusion Index',
  VitalTitleGlucose: 'Glucose',
  VitalTitleGlucoseFasting: 'Fasting Glucose',
  VitalTitleGlucoseBeforeMeal: 'Glucose Before Meal',
  VitalTitleGlucoseAfterMeal: 'Glucose After Meal',
  VitalTitleGlucoseCombined: 'Glucose',
  VitalTitleSystolicArterialBloodPressure: 'Systolic Arterial Pressure',
  VitalTitleDiastolicArterialBloodPressure: 'Diastolic Arterial Pressure',
  VitalTitleMeanArterialBloodPressure: 'Mean Arterial Pressure',
  VitalTitleCombinedArterialBloodPressure: 'Blood Pressure',
  VitalTitleWeight: 'Weight',
  VitalTitlePostureCalibration: 'Posture Calibration',
  VitalEarlyWarningScore: 'Early Warning Score',
  LabelDevice: 'Device',
  LabelDevices: 'Devices',
  LabelPatientFile: 'Patient file',
  ErrorCardTitle: 'Error',
  GenericErrorMessage: 'An error occurred',
  NoteListLoadingError: 'Error loading notes',
  NoteListReloadButtonText: 'Reload',
  RelayLoadingErrorText: 'Error loading relay status',
  RelayMBSIssuesTitle: 'MBS Issues',
  RelayIssuesTitle: 'Issues',
  RelayIssueTextNoIssues: 'No Issues',
  RelayWarningBadNetwork: 'Bad mobile network.',
  RelayWarningLowStorage: 'Low storage.',
  RelayWarningLowBattery: 'Low battery & not charging.',
  RelayWarningNoBluetoothDevices: 'No Bluetooth devices connected.',
  LabelNotifications: 'Notifications',
  NoAssignedDevicesErrorText: 'No assigned devices',
  NoWardSelectedErrorText: 'No ward selected',
  SelectWardErrorText: 'Please select a ward to view table',
  NoAssociatedDevicesFound: 'No Associated Devices Found',
  ErrorFetchingPatient: 'Error fetching patient',
  ErrorFetchingNextOfKin: 'Error fetching next of kin',
  DurationLabelDuration: 'Duration',
  DurationLabelCustom: 'Custom',
  DurationLabelLatest: 'Latest',
  DurationLabelFrom: 'From',
  DurationErrorInvalidDate: 'Please enter a valid date',
  DurationCustomSelectTimeFrame: 'Select time frame',
  ButtonTextSubmit: 'Submit',
  ButtonTextCancel: 'Cancel',
  ButtonTextClose: 'Close',
  ButtonTextBack: 'Back',
  ButtonTextReset: 'Reset',
  ButtonTextCopyConsultLink: 'Copy Link',
  ButtonTextInviteViaEmail: 'Email',
  ButtonTextInviteViaSms: 'SMS',
  ButtonTextInviteViaWhatsapp: 'WhatsApp',
  NoDataFallbackText: 'No data for selected period',
  AlertSuccess: 'Success',
  AlertError: 'Error',
  AlertErrorIncompleteForm:
    'Please ensure all items are completed before submitting',
  AlertCopySuccess: 'Your details have been copied',
  AlertCopyError: 'Could not copy invite',
  AlertSendInviteSuccessful: 'Meeting invite sent successfully',
  AlertSendInviteFailed: 'Could not send invite',
  AlertPatientLoadingError: 'Error loading patients',
  ButtonTextRetry: 'Retry',
  ErrorUpdatingPatient: 'Error updating patient information',
  ErrorUpdatingRelatedPerson: 'Error updating related person information',
  AddressLine1Error: 'Address Line 1 is required',
  PhoneNumberLineError:
    'Phone number is required with this format. e.g. +27123456789',
  MedicalAidSearchError: 'Error searching for patient',
  MedicalAidError: 'Error loading medical aid details',
  MedicalAidSearchSelectPatientTitle: 'Select patient',
  NextOfKinError: 'Error loading next of kin',
  DragFileToUpload: 'Drag file to upload',
  ChooseFile: 'Choose file',
  OrText: 'or',
  FileUploadingLabelText: 'Uploading',
  CreateDevice: 'Device details',
  DeviceCreateError: 'Error creating a new device',
  DeviceEditError: 'Error editing a device',
  DeviceDetails: 'Device details',
  LabelDeviceType: 'Device type',
  LabelDeviceStatus: 'Device status',
  LabelDeviceSerialNumber: 'Serial number',
  DisplayDeviceTypeRelay: 'Relay',
  DisplayDeviceTypeGlucose: 'Glucose',
  DisplayDeviceTypeBloodPressure: 'Blood pressure',
  DisplayDeviceTypePatch: 'Patch',
  DisplayDeviceTypeBand: 'Band',
  PlaceHolderDeviceType: 'Select a device type',
  PlaceHolderDeviceStatus: 'Select a device status',
  DisplayActive: 'active',
  DisplayInactive: 'inactive',
  DisplayEnteredInError: 'entered in error',
  FormLabelActive: 'Active',
  FormLabelAssignedOrgOrTeams: 'Assigned Team or Departments',
  CardTitleAdmissionDetails: 'Admission Details',
  FormLabelPrimaryICD10Codes: 'Primary ICD-10 Code',
  FormLabelICD10Codes: 'ICD-10 Codes',
  FormLabelAllergies: 'Allergies',
  FormLabelSeverity: 'Severity',
  PractitionerDeactivateDialogButtonText: 'Deactivate',
  PractitionerDeactivateDialogTitle: 'Deactivate Practitioner',
  PractitionerDeactivateDialogMessage:
    'Are you sure you want to make this practitioner inactive?',
  PractitionerActivateDialogButtonText: 'Activate',
  PractitionerActivateDialogTitle: 'Activate Practitioner',
  PractitionerActivateDialogMessage:
    'Are you sure you want to make this practitioner active?',
  PatientDischargeDialogButtonText: 'Discharge',
  PatientDischargeDialogTitle: 'Discharge Patient',
  PatientDischargeDialogMessage:
    'Are you sure you want to discharge this patient?',
  PatientReadmitDialogButtonText: 'Readmit',
  PatientReadmitDialogTitle: 'Readmit Patient',
  PatientReadmitDialogMessage: 'Are you sure you want to readmit this patient?',
  AdmissionServiceLabel: 'Quro Medical offering',
  AdmissionServiceOptionAll: 'All Services',
  AdmissionStartLabel: 'Date of admission',
  AdmissionStatusLabel: 'Status',
  AdmissionStatusAdmitted: 'Admitted',
  AdmissionStatusOnboarded: 'Onboarded',
  AdmissionStatusDischarged: 'Discharged',
  AdmissionStatusInvalidated: 'Invalidated',
  AdmissionDischargeLabel: 'Date of discharge',
  AdmissionOnboardingLabel: 'Date of onboarding',
  AdmissionEndLabel: 'End of admission',
  AdmissionServiceHospitalAtHome: 'Hospital at home',
  AdmissionServiceHospitalAtHomeUpgrade: 'Hospital At Home Upgrade',
  AdmissionServiceTCP: 'TCP',
  AdmissionServiceSPHERE: 'QuroSPHERE',
  AdmissionServiceRemotePatientMonitoring: 'Remote patient monitoring',
  AdmissionServiceArthroplasty: 'Arthroplasty',
  AdmissionServiceHealingHands: 'Healing Hands',
  AdmissionServiceInHospitalMonitoring: 'In Hospital Monitoring',
  AdmissionServiceCareAtHome: 'Care At Home',
  AdmissionServiceLace: 'Lace',
  AdmissionServiceShortHospitalAtHome: 'HaH',
  AdmissionServiceShortHospitalAtHomeUpgrade: 'HahUPG',
  AdmissionServiceShortSPHERE: 'SPHERE',
  AdmissionServiceShortTCP: 'TCP',
  AdmissionServiceShortRemotePatientMonitoring: 'RPM',
  AdmissionServiceShortArthroplasty: 'ARTH',
  AdmissionServiceShortHealingHands: 'HH',
  AdmissionServiceShortInHospitalMonitoring: 'IHM',
  AdmissionServiceShortCareAtHome: 'CaH',
  AdmissionClass: 'Admission type',
  AdmissionClassHome: 'Home Care',
  AdmissionClassHospital: 'In Hospital Care',
  AdmissionAuthorizationDateLabel: 'Date of authorization',
  AdmissionAuthorizationCodeLabel: 'Medical aid authorization code',
  RequiredOxygenFormLabel: 'Supplemental Oxygen',
  RequiredOxygenQuantityFormLabel: 'Oxygen (l/min)',
  AdmissionAuthorizationFormTitle: 'Authorization',
  AdmissionNotesFormTitle: 'Admission notes',
  AdmissionClinicalFormTitle: 'Clinical details',
  AdmissionDrawerTitle: 'Admit',
  AdmissionCardTitle: 'Admission',
  AdmissionButtonTextCreate: 'Create Admission',
  CarePlanButtonTextCreate: 'Create Care Plan',
  AdmissionStartPlannedButtonText: 'Start Admission',
  AdmissionServiceFormLabel: 'Service',
  AdmissionServiceNoneText: 'None',
  AdmissionDurationPrefixDay: 'Day',
  EncounterStatusEnteredInError: 'Entered in error',
  EncounterStatusInProgress: 'In progress',
  EncounterStatusArrived: 'Arrived',
  EncounterStatusCancelled: 'Cancelled',
  EncounterStatusFinished: 'Finished',
  EncounterStatusOnLeave: 'Paused',
  EncounterStatusPlanned: 'Planned',
  EncounterStatusTriaged: 'Triaged',
  EncounterStatusUnknown: 'Unknown',
  CardTitleInactiveMedicalAidMembers: 'Inactive medical aid members',
  CardLabelInactiveMembers: 'Members',
  CardLabelInactiveMedicalAidReason: 'Reason',
  FormTitleCreateMedia: 'Create Media',
  FormTitleCreateGroup: 'Create Group',
  MediaFileNameSubheading: 'File Name',
  MediaPractitionerSubheading: 'Practitioner',
  MediaDownloadSubheading: 'Download',
  MediaDownloadButtonText: 'Download file',
  MediaDownloadContactDetails: 'Download Contact',
  MediaViewButtonText: 'View file',
  GroupsFormLabel: 'Groups',
  LabelGroupName: 'Group Name',
  LabelGroupType: 'Group Type',
  NoGroupsAssigned: 'No groups assigned',
  NoPatientsAssigned: 'No patients assigned',
  PlaceHolderGroupName: 'Enter Group Name',
  PlaceHolderGroupType: 'Enter Group Type',
  PlaceHolderSelectOption: 'Select option',
  PlaceHolderAddPermissions: 'Add permissions',
  PlaceHolderSelectOrganization: 'Select organization',
  PlaceHolderLocationCapacity: 'Location Capacity e.g. 15',
  PlaceHolderSearch: 'Type to search',
  LabelActive: 'Active',
  DisplayNotFound: 'Display not found',
  LabelPermissions: 'Permissions',
  LabelOrganization: 'Organization',
  CardTitleGroupDetails: 'Group Details',
  CardTitleAddGroupMembers: 'Add Members',
  ButtonTextAddGroupMembers: 'Add members',
  CardTitleGroupEdit: 'Edit Group',
  UserProfileCardTitle: 'User Profile',
  UserProfileLinkText: 'Profile',
  ResourceNameMissing: 'Display name not found',
  FormLabelPreferences: 'Preferences',
  HospitalSettings: 'Hospital Settings',
  SelectedWards: 'Selected Wards',
  ManageWards: 'Manage Wards',
  MovePatientsToWard: 'Move patients to ward',
  ChangeWard: 'Change ward',
  Move: 'Move',
  Patients: 'Patients',
  Patient: 'Patient',
  FormLabelTheme: 'Theme',
  FormOptionThemeDark: 'Dark',
  FormOptionThemeLight: 'Light',
  FormOptionThemeSystem: 'System',
  FormOptionThemeContrastDark: 'High Contrast',
  PreferenceUpdateErrorMessage: 'Error updating user preferences',
  ToggleDisplayAdmissions: 'Admissions',
  ToggleDisplayPatients: 'Patients',
  CardTitleOrganizationDetails: 'Organization details',
  CardTitleOrganizationEdit: 'Edit Organization',
  LabelOrganizationType: 'Type',
  LabelOrganizationSchemeCode: 'Scheme code',
  LabelVirtualHospital: 'Virtual Hospital',
  LabelManagingOrganization: 'Managing Organization',
  LocationCreateError: 'Error creating a new location',
  LocationEditError: 'Error editing a device',
  LocationDetails: 'Location details',
  LocationParent: 'Parent',
  LocationStatus: 'Status',
  LocationToggleCardTitle: 'Create Location',
  LocationToggleCardExpandButtonText: 'Create Location',
  LocationToggleCardCollapseButtonText: 'Hide',
  CardTitleLocationDetails: 'Location details',
  LocationTableNameSubheading: 'Name',
  LocationTableOrganizationSubheading: 'Managing Organization',
  LocationTableParentSubheading: 'Parent',
  LocationSelectType: 'Select Type',
  LabelLocationType: 'Type',
  LabelLocationAcuity: 'Acuity',
  LabelLocationCapacity: 'Capacity',
  LabelLocationDescription: 'Description',
  FormLabelLocationDetails: 'Location Details',
  DefaultLocationParent: 'No parent location linked',
  DefaultLocationOrganization: 'Error Retrieving Organization',
  StatusPlaceholder: 'Enter Status',
  ParentPlaceholder: 'Select Parent',
  ManagingOrganizationPlaceholder: 'Select Organization',
  NamePlaceholder: 'Enter Name',
  DescriptionPlaceholder: 'Enter Description',
  FormLabelMembers: 'Members',
  FormTitleCreateOrganization: 'Create Organization',
  CardTitlePractitionerDetails: 'Practitioner details',
  CardTitlePractitionerEdit: 'Edit Practitioner',
  LabelPractitionerError: 'Cannot Create a Practitioner, please try again',
  FormLabelPersonDetails: 'Details',
  FormLabelPersonContactDetails: 'Contact details',
  FormLabelPractitionerQualificationDetails: 'Qualification',
  FormLabelPractitionerCanPrescribeSettings: 'Settings',
  FormLabelPractitionerCanPrescribe: 'Can prescribe',
  ButtonTextSubmitPractitioner: 'Create Practitioner',
  FormTitlePractitionerInitialGroup: 'Initial group',
  FormLabelPractitionerGroup: 'Group',
  QualificationCode: 'Qualification code',
  CardTitleIAmNew: 'I am a new',
  ToggleCardCollapseButtonTextHide: 'Hide',
  PractitionerToggleCardTitle: 'Create Practitioner',
  PractitionerToggleCardExpandButtonText: 'Create Practitioner',
  PractitionerToggleCardCollapseButtonText: 'Hide',
  OrganizationToggleCardTitle: 'Create Organization',
  OrganizationToggleCardExpandButtonText: 'Create Organization',
  OrganizationToggleCardCollapseButtonText: 'Hide',
  GroupToggleCardTitle: 'Create Group',
  GroupToggleCardExpandButtonText: 'Create Group',
  GroupToggleCardCollapseButtonText: 'Hide',
  DeviceToggleCardTitle: 'Create Device',
  DeviceToggleCardExpandButtonText: 'Create Device',
  DeviceToggleCardExpandSecondaryButtonText: 'Create Bulk Devices',
  DeviceToggleCardCollapseButtonText: 'Hide',
  TitleCreateDeviceAssociation: 'Create Device Association',
  LabelCreateDeviceAssociation: 'Create Association',
  DeviceAssociationActiveAdmissionServiceLabel: 'Active Admission',
  TitlePatient: 'Patient',
  TitlePractitioner: 'Practitioner',
  ButtonTextRegister: 'Register',
  ButtonTextLearnMore: 'Learn more',
  TitleRegisterNow: 'Register now',
  TitleNewToQuroMedical: 'New to Quro Medical?',
  TitleDownloadOurApp: 'Download our app',
  LabelVitalLatest: 'Latest',
  TitleVitalLatest: 'Latest Vitals',
  TechIssueTitle: 'Device',
  EWSTitle: 'EWS',
  EWSTitleLong: 'Early Warning',
  NEWS2ScoreTitle: 'NEWS2',
  NEWS2ScoreTitleLong: 'NEWS2 Score',
  NEWS2ScoreLabelLowRisk: 'Low Risk',
  NEWS2ScoreLabelLowMediumRisk: 'Low-medium Risk',
  NEWS2ScoreLabelMediumRisk: 'Medium Risk',
  NEWS2ScoreLabelHighRisk: 'High Risk',
  NEWS2ScoreLabelShortLowRisk: 'Low',
  NEWS2ScoreLabelShortLowMediumRisk: 'Low-medium',
  NEWS2ScoreLabelShortMediumRisk: 'Medium',
  NEWS2ScoreLabelShortHighRisk: 'High',
  NEWS2ScoreLabelUnknownRisk: 'Unknown',
  MedicationsCardTitle: 'Medication',
  MedicationRequestStatusCartTitle: 'Creating of scripts is unavailable',
  MedicationStatementsStatusCartTitle:
    'Creating of medication statements unavailable',

  LabelMedication: 'Medication',
  LabelMedicationAdministration: 'Administration',
  LabelMedicationNappiCode: 'Medication Nappi Code',
  MedicationPlaceholder: 'Medication Search',
  LabelMedicationFrequency: 'Frequency',
  LabelMedicationDuration: 'Duration',
  LabelMedicationType: 'Type',
  MedicationRepeatPlaceholder: 'eg. 3 times',
  LabelMedicationPeriodUnit: 'Period Unit',
  MedicationPeriodUnitPlaceholder: 'eg. Daily',
  LabelMedicationPeriod: 'Period',
  MedicationPeriodPlaceholder: 'eg. Daily',
  LabelMedicationNoteText: 'Instructions',
  LabelMedicationRefill: 'Refills',
  LabelMedicationGenerics: 'Generics',
  LabelPrescriber: 'Choose Prescribing Doctor',
  LabelRecipient: 'Send script to',
  LabelPatientRecipient: 'Select patient to confirm',
  LabelRecipientPatientPicker: 'Confirm patient as recipient',

  MedicationNoteTextPlaceholder: 'take with meals',
  FormTitleCreateMedicationStatement: 'Create Medication Statement',
  FormTitleCreateMedicationRequest: 'Create Medication Request',
  LabelMedicationName: 'Medication',
  LabelMedicationRoute: 'Medication Route',
  CardTitleMedicationDetails: 'Medication Details',
  LabelMedicationStrength: 'Medication Strength',
  LabelMedicationVolume: 'Volume',
  LabelMedicationDosage: 'Medication Dosage',
  LabelMedicationStatus: 'Medication Status',
  LabelMedicationPrescriber: 'Created by',
  NEWS2OxygenSaturationLabelScale1: 'Scale 1 (air)',
  NEWS2OxygenSaturationLabelScale2Oxygen: 'Scale 2 (oxygen)',
  NEWS2OxygenSaturationLabelScale2Air: 'Scale 2 (air)',
  PatientPrintSummaryPlaceholderNoNotes: 'No notes',
  PatientPrintTitleNoVitals: 'No vitals',
  NoteHistoryTitle: 'History',
  MedicationRequestRefillOnce: 'Once',
  MedicationRequestRefillTwice: 'Two times',
  MedicationRequestRefillThreeTimes: 'Three times',
  MedicationRequestNoRefill: 'No repeats',
  MedicationFrequencyDaily: 'One/day',
  MedicationFrequencyBiDaily: 'Two/day',
  MedicationFrequencyThreeTimesADay: 'Three/day',
  MedicationFrequency4Hourly: 'Four hourly',
  MedicationFrequency6Hourly: 'Six hourly',
  MedicationFrequencyNightOnly: 'Night only',
  MedicationFrequencyMorningOnly: 'Morning only',
  MedicationFrequencyAsNeeded: 'As needed',
  MedicationPrescriptionLength1Day: '1 day',
  MedicationPrescriptionLength3Days: '3 days',
  MedicationPrescriptionLength5Days: '5 days',
  MedicationPrescriptionLength7Days: '7 days',
  MedicationPrescriptionLength14Days: '14 days',
  MedicationPrescriptionLength1Month: '1 month',
  MedicationNameSubheading: 'Medication',
  MedicationSelectionSubheading: 'Select a medication',
  MedicationNappiCodeSubheading: 'NAPPI Code',
  MedicationTypeSubheading: 'Type',
  MedicationDosageSubheading: 'Dosage',
  MedicationRepeatSubheading: 'Repeat',
  MedicationStrengthSubheading: 'Strength',
  MedicationVolumeSubheading: 'Volume',
  MedicationRouteSubheading: 'Route',
  MedicationAdministrationSubheading: 'Administration',
  MedicationScheduleSubheading: 'Schedule',
  MedicationActionsSubheading: 'Actions',
  MedicationRequestHeading: 'Medication Requests',
  TitleUrgentClinicalReview: 'Urgent Clinical Review',
  TitleUrgentClinicalReviewCritical: 'Urgent Clinical Review (High)',
  TitleTechnicalReview: 'Technical Review',
  TitleRealtimeAlert: 'Realtime Alerts',
  ValueNotAvailable: 'N/A',
  PathologyButtonTextCreateRequest: 'New request',
  PathologyButtonTextHide: 'Hide',
  PathologyOrderNumberSubheading: 'Order Number',
  PathologyOrderNameSubheading: 'Test Name',
  PathologyOrderInterpretationSubheading: 'Interpretation',
  PathologyOrderResultSubheading: 'Result',
  PathologyOrderReferenceRangeSubheading: 'Reference Range',
  PathologyRequestStatusSubheading: 'Request Status',
  PathologyRequestDateSubheading: 'Request Date',
  PathologySampleSubheading: 'Sample Date Time',
  PathologyTestsSubheading: 'Tests',
  PathologyNotesSubheading: 'Notes',
  PathologyCopiedDoctorsSubheading: 'Copied Doctors',
  PathologyCreateCardTitle: 'Create Pathology Request',
  PathologyReportDateSubheading: 'Report Date',
  PathologyReportStatusSubheading: 'Report Status',
  PathologyDownloadButtonTitle: 'Download Report',
  PathologyDrawerTitle: 'Pathology',
  PathologyWarningCardLabel: 'Pathology requests unavailable',
  PathologyProviderAmpath: 'Ampath',
  PathologyProviderLancet: 'Lancet',

  ButtonTextOpenMaps: 'Open Maps',
  ButtonTextNoMapLink: 'No Map Link',
  TitleAddressDetails: 'Address Details',
  PathologyRequestsTabTitle: 'Requests',
  PathologyReportsTabTitle: 'Reports',

  VitalsActiveTabTitle: 'Active Vitals',
  VitalsTrackingTabTitle: 'Vital Tracking',

  // KBar strings
  KBarHomeTitle: 'Home',
  KBarHomeSubtitle: 'Go to the home screen',

  KBarDashboardTitle: 'Dashboard',
  KBarDashboardSubtitle: 'Go to dashboard',

  KBarPatientTitle: 'Patients',
  KBarPatientSubtitle: 'Go to Patient List',

  KBarAdmissionTitle: 'Admissions',
  KBarAdmissionSubtitle: 'Go to Admissions List',

  KBarActiveAdmissionsTitle: 'Active Patients',
  KBarActiveAdmissionsSubtitle: 'View Patients with Active Admissions',

  KBarAdminOnboardPrivateTitle: 'Onboard Private',
  KBarAdminOnboardPrivateSubtitle:
    'Onboard Patient without Medical Aid Details',
  KBarAdminOnboardMedicalAidTitle: 'Onboard Medical Aid',
  KBarAdminOnboardMedicalAidSubtitle: 'Onboard Patient with Medical Aid',

  KBarActiveAdmissionActionSubtitlePrefix: 'For ',

  KBarActiveAdmissionActionProfileTitle: 'Profile',
  KBarActiveAdmissionActionVitalsTitle: 'Vitals',
  KBarActiveAdmissionActionClinicalTitle: 'Clinical',
  KBarActiveAdmissionActionNotesTitle: 'Notes',
  KBarActiveAdmissionActionPathologyTitle: 'Pathology',
  KBarActiveAdmissionActionMediaTitle: 'Media',
  KBarActiveAdmissionActionVideoConsultTitle: 'Video Consult',

  KBarCurrentPatientActionTitleSubtitle: 'Current Patient',

  ActionListSubtitleTime: 'Time',

  // alerts
  AlertTitleECGNonSinusRhythm: 'Non-sinus rhythm',
  AlertRowTitleTime: 'Time',

  LabelSearchAddresses: 'Search Addresses',

  DeviceTableNameSubheading: 'Name',
  DeviceTableTypeSubheading: 'Type',
  DeviceTableStatusSubheading: 'Status',

  MyPatients: 'My Patients',

  VitalObservationFormTitlePrefix: 'Add',
  VitalObservationFormTitleSuffix: 'Measurement',
  VitalObservationFormLabelMeasure: 'Measurement',
  VitalObservationFormLabelDateTime: 'Date and Time',
  VitalObservationFormLabelValue: 'Value',
  VitalObservationFormLabelUnit: 'Unit',

  VitalObservationDeviceName: 'Manually Added',

  VitalsFilterFormLabel: 'Monitoring Level',

  MonitoringConfigurationLabel: 'Monitoring Intensity',
  MonitoringConfigurationHighIntensity: 'High Intensity',
  MonitoringConfigurationMediumIntensity: 'Medium Intensity',
  MonitoringConfigurationLowIntensity: 'Low Intensity',
  ReferPatient: 'Refer patient',

  TinyMDMGeoPositionLabel: 'Latest Geolocation Position',
  TinyMDMErrorTitle: 'Error',
  TinyMDMErrorText: 'Could not load the TinyMDM status',
  TinyMDMRebootButton: 'Reboot device',
  TinyMDMStatusTitle: 'TinyMDM Status',
  TinyMDMRebootErrorTitle: 'Reboot error',
  TinyMDMRebootErrorText: 'Could not reboot the device remotely',

  LabelGivenName: 'Given Name',
  LabelFamilyName: 'Family Name',
  LabelAction: 'Action',
  LabelDownload: 'Download',
  LabelMarkAsError: 'Mark as Error',
  LabelStart: 'Start',
  LabelEnd: 'End',
  LabelSubject: 'Subject',
  LabelEntity: 'Entity',
  LabelEditTitle: 'Edit Title',
  LabelCountryPickerTitle: 'Select a country',

  PaginationControlsLabelPage: 'Page',
  DeviceMetricListTitle: 'Calibration History',

  NestedFormTextRequired: 'Text is required',

  // alert form
  AlertQualityHigh: 'High',
  AlertQualityMedium: 'Medium',
  AlertQualityLow: 'Low',

  AlertTypeLabel: 'Type',
  AlertTimeLabel: 'Time',
  AlertQualityLabel: 'Data quality',
  AlertClassificationLabel: 'Clinical conditions',
  AlertDetailsLabel: 'General comments',
  AlertCommentFormTitle: 'Add alert comment',

  TitleSelectPatient: 'Select patient',
  ErrorTextPatientIdNumberRequired: 'Patient ID Number is Required',
  MedicalAidUpdateSubmissionError: 'Error updating medical aid details',
  MedicalAidUpdateValidationError: 'Main member details are not valid',
  MedicalAidPatientSelectionEmpty: 'No members found',
  MedicalAidPatientUpdateSearchFormTitle: 'Update medical aid details',
  MedicalAidPatientUpdateSearchError: 'No results found',

  ChargeLineAppliesOptionLabel: 'Applies to',
  ChargeLineAppliesOptionScheme: 'Scheme',
  ChargeLineAppliesOptionAdministrator: 'Administrator',
  ChargeLineAppliesSchemeOrAdministrator: 'Scheme or administrator',
  ChargeLineItemAmountLabel: 'Amount (cents)',
  ChargeLineItemCodeLabel: 'Charge Code',

  ChargeLineUnitPrice: 'Unit Price',
  ChargeLineTotalPrice: 'Total Price',

  FormListAddItem: 'Add Item',
  FormListRemoveItem: 'Remove Item',

  ChargeLineFormTitle: 'Add Item',
  ChargeItemDefinitionFormLabelName: 'Name',
  ChargeItemDefinitionFormLabelDescription: 'Description',
  ChargeItemDefinitionFormLabelEffectivePeriod: 'Effective period',
  ChargeItemDefinitionFormLabelEffectivePeriodStart: 'Effective From',
  ChargeItemDefinitionFormLabelEffectivePeriodEnd: 'Effective Till',

  ChargeItemDefinitionFormLabelChargeLines:
    'Claim Line by Scheme or Administrator',

  ChargeItemDefinitionFormCreateTitle: 'Create Charge Line',
  ChargeItemDefinitionFormEditTitle: 'Edit Charge Line',
  ChargeItemDefinitionFormSubmissionError: 'Error submitting form',
  ChargeItemDefinitionFormItemsError: 'Charge lines not valid',

  ChargeItemDefinitionViewTitle: 'View item',
  ChargeItemDefinitionListTitle: 'Charge Items',

  ClaimLineQuantityLabel: 'Quantity',
  ClaimLineChargeItemLabel: 'Charge item',
  ClaimLineFormTitle: 'Add Item',
  ClaimLabelDate: 'Claim date',

  ClaimTemplateFormSubmissionError: 'Error submitting form',
  ClaimTemplateFormItemsError: 'Items not valid',

  ClaimTemplateFormCreateTitle: 'Create claim template',
  ClaimTemplateFormEditTitle: 'Update claim template',

  ClaimTemplateFormLabelService: 'Service type',

  ClaimTemplateViewTitle: 'View item',
  ClaimTemplateListTitle: 'Claim templates',

  ClaimViewTitle: 'View item',
  ClaimListTitle: 'Claims',
  ClaimEditTitle: 'Edit claim',

  ClaimResponseStatusDescription: 'Status Description',
  ClaimResponseClaimedAmount: 'Claimed Amount',
  ClaimResponsePaidProvider: 'Paid Provider',
  ClaimResponseBalanceOutstanding: 'Balance Outstanding',
  ClaimResponseItem: 'Item',
  ClaimResponseBilledAmount: 'Billed amount',
  ClaimResponseMedicalAidPayable: 'Medical aid payable',
  ClaimResponseMedicalAidRate: 'Medical aid rate',
  ClaimResponseNotes: 'Notes',
  ClaimResponseOutcome: 'Outcome',
  ClaimResponseLabelDate: 'Claim response date',

  ClaimReversalConfirmationButtonTitle: 'Reverse claim',
  ClaimReversalConfirmationButtonText: 'Reverse claim',
  ClaimReversalConfirmationButtonMessage:
    'Are you sure you want to reverse this claim? This cannot be undone!',

  ClaimNavigationToggleClaim: 'Claims',
  ClaimNavigationToggleResponse: 'Responses',

  LabelInvoiceNumber: 'Invoice number',

  ClaimSubmitMessage: "Submit claim to the patient's medical aid",
  ClaimSubmitTitle: 'Submit claim',

  AmpathRequestTestTypeNormalOption: 'Normal',
  AmpathRequestTestTypeSpecialOption: 'Special Order',
  AmpathRequestTestsSpecialLabel: 'Special Test',
  AmpathMnemonic: 'Ampath Mnemonic',

  PathologyRequestTestTypeLabel: 'Test Type',
  PathologyRequestTestsNormalLabel: 'Ordered Tests',
  PathologySampleDateTimeLabel: 'Sample Date and Time',
  PathologyCommentLabel: 'Notes',
  PathologyCopyDoctorsLabel: 'Copy Doctors',

  FormLabelPractitionerExternal: 'External',

  TaskButtonAddNote: 'Update Task',
  TaskLabelDescription: 'Description',
  TaskLabelAuthor: 'Author',
  TaskLabelOwner: 'Owner',
  TaskLabelDateCreated: 'Date created',
  TaskLabelDateUpdated: 'Date updated',
  TaskLabelCreatedBy: 'Created by',
  TaskLabelAssignedTo: 'Assigned to',
  TaskLabelStatus: 'Status',
  TaskLabelNotes: 'Notes',
  TaskListTitle: 'Tasks',
  TaskListTaskHeading: 'Task',
  TaskButtonViewItem: 'View details',
  TaskLabelRequestedBy: 'Requested by',
  TaskLabelUpdatedBy: 'Updated by',
  TaskLabelDueDate: 'Due Date',
  TaskLabelTeam: 'Team',
  TaskLabelMe: 'Me',

  TaskButtonViewDevice: 'View device',
  TaskButtonViewOrganization: 'View organization',
  TaskButtonViewClinicalImpression: 'View clinical note',
  TaskButtonViewObservation: 'View observation',
  TaskButtonViewServiceRequest: 'View pathology request',
  TaskButtonViewMedicationRequest: 'View prescription',
  TaskButtonViewEncounter: 'View admission',
  TaskButtonViewCoverage: 'View medical aid',
  TaskButtonViewMedia: 'View media',

  FormLabelSendToPatient: 'Patient',
  TaskAssignmentNoteLabel: 'Description',
  TaskAssignmentLabelSuffix: 'assigned',
  TaskAssignmentLabel: 'Assign task',
  TaskAssignmentLabelCode: 'Type',
  TaskAssignmentLabelPerformer: 'Assign to',
  TaskAssignmentInvalidPerformerError:
    'Assignee type does not align to a known type of person or organization',

  MedicationRequestDosageInstructionAdministrationBuccal: 'Buccal',
  MedicationRequestDosageInstructionAdministrationInhalation: 'Inhalation',
  MedicationRequestDosageInstructionAdministrationIntramuscular:
    'Intramuscular',
  MedicationRequestDosageInstructionAdministrationIntranasal: 'Intranasal',
  MedicationRequestDosageInstructionAdministrationIntravenous: 'Intravenous',
  MedicationRequestDosageInstructionAdministrationOral: 'Oral',
  MedicationRequestDosageInstructionAdministrationRectal: 'Rectal',
  MedicationRequestDosageInstructionAdministrationSubcutaneous: 'Subcutaneous',
  MedicationRequestDosageInstructionAdministrationSublingual: 'Sublingual',
  MedicationRequestDosageInstructionAdministrationTopical: 'Topical',
  MedicationRequestDosageInstructionAdministrationTransdermal: 'Transdermal',
  MedicationRequestDosageInstructionAdministrationVaginal: 'Vaginal',

  TaskCodeDisplayClinicalImpressionFollowUp: 'Follow up on clinical note',
  TaskCodeDisplayClinicalImpressionReview: 'Review clinical note',
  TaskCodeDisplayServiceRequestCreate: 'Create pathology request',
  TaskCodeDisplayDiagnosticReportFollowUp: 'Follow up on report',
  TaskCodeDisplayMedicationRequestCreate: 'Create prescription',
  TaskCodeDisplayMedicationRequestFollowUp: 'Follow up on prescription',
  TaskCodeDisplayMediaFollowUp: 'Follow up on media',
  TaskCodeDisplayOtherContact: 'Contact',
  TaskCodeDisplayOtherSchedule: 'Schedule',
  TaskCodeDisplayHomeVisit: 'Perform home visit',
  TaskCodeDisplayClinicalCallOut: 'Perform clinical call out',

  TaskStatusDisplayActive: 'Active',
  TaskStatusDisplayInactive: 'Inactive',
  TaskStatusDisplayCompleted: 'Completed',
  TaskStatusDisplayInProgress: 'In Progress',
  TaskStatusDisplayRequested: 'Requested',
  TaskStatusDisplayCancelled: 'Cancelled',
  TaskStatusDisplayOverdue: 'Over Due',

  AllergyLabel: 'Allergy',
  AllergyCode: 'Code',
  AllergyName: 'Name',
  AllergyType: 'Type',
  AllergySeverity: 'Severity',
  AllergySevere: 'Severe',
  AllergyMild: 'Mild',
  AllergyUnknown: 'Unknown',
  AllergyRecorder: 'Practitioner',
  AllergyCreateTitle: 'Create Allergy',

  LabelConsumable: 'Consumable',
  LabelConsumableQuantity: 'Quantity',
  LabelUsedConsumables: 'Used Consumables',
  LabelConsumableUsageDate: 'Date of use',
  LabelConsumablePractitioner: 'Practitioner',
  LabelConsumableActions: 'Actions',
  ConsumableConfirmationButtonTitle: 'Mark as Error',
  ConsumableConfirmationButtonText: 'Mark as Error',
  ConsumableConfirmationButtonMessage:
    'Are you sure you want mark this consumable as entered in error?',

  NotSpecified: 'Not Specified',
  AdmissionPause: 'Pause',
  AdmissionResume: 'Resume',
  AdmissionStart: 'Start',
  AdmissionInvalidate: 'Invalidate',
  AdmissionPausedLabel: 'Paused',
  AdmissionResumeLabel: 'Resumed',
  AdmissionPausedDialogTitle: 'Admission Pause',
  AdmissionPausedDialogMessage:
    'Are you sure you want to pause this admission?',
  AdmissionResumeDialogTitle: 'Admission Resume',
  AdmissionResumeDialogMessage:
    'Are you sure you want to resume this admission?',
  AdmissionInvalidateDialogTitle: 'Invalidate Admission',
  AdmissionInvalidateDialogMessage:
    'Are you sure you want to invalidate this admission?',
  AdmissionCarePlanCreateTitle: 'Create admission care plan',
  AdmissionCarePlanDialogMessage:
    'Are you sure you want to create this care plan?',
  AdmissionCarePlanLabel:
    'Which care plan would you like to onboard the patient to?',
  AdmissionStartPlannedTitle: 'Start Planned Admission',

  AdmissionStartPlannedMessage:
    'Are you sure you want to start this admission?',

  AdmissionDayOfService: 'Day of service',
  AdmissionDay: 'Day',
  DiagnosisLabelRFA: 'Reason of admission ICD-10 Codes',
  DiagnosisLabelChronic: 'Chronic ICD-10 Codes',
  DiagnosisLabelAcute: 'Acute ICD-10 Codes',
  HeadingReasonOfAdmission: 'Reason of Admission',
  HeadingDuringOfAdmission: 'During Admission',

  AllergyDialogTitle: 'Remove patient allergy',
  AllergyDialogMessage: 'Are you sure you want to remove this allergy?',
  AllergyDialogButtonText: 'Remove',

  FormLabelIsPregnant: 'Is pregnant',
  FormLabelIsLactating: 'Is Lactating',
  FormCardLabelPregnant: 'Pregnant',
  FormCardLabelLactation: 'Lactation',
  FormLabelEDD: 'Estimate date of delivery ',

  CareTeamCreateError: 'Error creating a new care team',
  CareTeamEditError: 'Error editing a device',
  CareTeamDetails: 'Care team details',

  CareTeamStatus: 'Status',
  CareTeamToggleCardTitle: 'Create Care team',
  CareTeamToggleCardExpandButtonText: 'Create Care team',
  CareTeamToggleCardCollapseButtonText: 'Hide',
  CareTeamTableNameSubheading: 'Name',
  CareTeamTableOrganizationSubheading: 'Managing Organization',

  CardTitleCareTeamPractitioner: 'Care team or Practitioner',
  CardTitleCareTeamDetails: 'Care team details',
  CareTeamOrganizationError: 'Error Retrieving Organization',
  CareTeamOrganizationOfPractitioner: 'Organization of the practitioner',
  CareTeamError: 'Error Retrieving Care Teams',
  LabelShowAll: 'Show All',
  LabelRole: 'Role',

  WarningNoMedicalAid: 'Patient does not have medical aid',
  WarningNoAdmission: 'Patient does not have an active admission',

  AdmissionButtonContinue: 'Continue admission',

  CommunicationAlertTitle: 'Unread messages',
  CommunicationAlertSubHeading: 'Messages',
  CommunicationUserSystem: 'system',
  CommunicationSelectTemplates: 'Select Templates',
  CommunicationTitle: 'Communication',

  PathologyServiceRequestsScreen: 'Service Requests',
  PathologyDiagnosticResults: 'Pathology Results',
  PathologyViewReport: 'View Results',
  PathologyTestResults: 'Results',

  PatientSearchFormLabel: 'Search',
  PatientSearchFormPlaceholder: 'Search something about this patient...',
  PatientSearchFormButton: 'Search',
  PatientSearchFormTitle: 'AI Search',
  PatientSearchResultCardTitle: 'Search Results',
  PatientSearchWarningLabel: 'Please be aware of the following:',
  PatientSearchWarningItem1:
    '• This AI search feature is in beta and it can’t be used for direct diagnosis or treatment of the patient',
  PatientSearchWarningItem2:
    '• AI-generated content may be inaccurate or biased, so it must always be reviewed. Consider any summary or answer as a draft, not final.',
  PatientSearchWarningItem3:
    '• The search results may not be reliable for patients under 18 or over 85 years old due to limited testing data on this AI solution.',
  PatientSearchWarningTitle: 'Caution',
  PatientSearchWarningButtonTitle: 'Dismiss',

  AdmissionDischargeReasonLabel: 'What is the reason for discharge?',
  AdmissionInvalidateReasonLabel: 'What is the reason for invalidation?',
  AdmissionPauseReasonLabel: 'What is the reason for pausing?',

  LabelBandStatusBattery: 'Battery level',
  LabelBandStatusWear: 'Wear status',
  LabelBandStatusWearing: 'Patient is wearing the band',
  LabelBandStatusNotWearing: 'Patient is not wearing the band',
  LabelBandStatusDevice: 'Device Status',
  LabelBandStatusDeviceOk: 'Device is working normal',
  LabelBandStatusDeviceNotWearing: 'Device is not worn by the patient',
  LabelBandStatusDeviceDisconnected:
    'Device is disconnected from the mobile network',
  LabelBandStatusDeviceCharging: 'Device is charging',
  LabelBandStatusDeviceLowBattery: 'Device has low battery',
  LabelBandStatusDeviceCriticalLowBattery: 'Device has critical low battery',
  LabelBandStatusDeviceSensor: 'Sensor quality',
  LabelBandStatusDeviceSensorOk: 'Sensor quality is normal',
  LabelBandStatusDeviceSensorLow:
    'Sensor quality is low, his could indicate that the patient is not wearing the device correctly or is exercising.',
  LabelBandStatusTitle: 'Band Status',
  LabelBandStatusNotFound: 'Status not found',

  DocumentListTitle: 'Documents',
  DocumentTitle: 'Title',
  DocumentStatus: 'Status',
  DocumentAuthor: 'Author',
  DocumentType: 'Type',
  DocumentDate: 'Date',
  DocumentCreate: 'Create Document',
  DocumentDeviceName: 'Device Name',
  DocumentMotivationMedicalDevice: 'Motivation Medical Device',
  DocumentReasonForReferral: 'Reason for Referral',
  DocumentMedicalHistory: 'Medical History',
  DocumentCurrentTreatment: 'Current Treatment',
  DocumentRecentInvestigations: 'Recent Investigations',
  DocumentExternalPractitionerName: 'External Practitioner Name',
  DocumentExternalPractitionerPhone: 'External Practitioner Phone',
  DocumentExternalPractitionerDiscipline: 'External Practitioner Discipline',
  DocumentExternalPractitionerEmail: 'External Practitioner Email',
  DocumentDownload: 'Download',

  ClinicalSummaryWarningLabel: 'Warning',
  ClinicalSummaryWarningMessage:
    'This clinical summary is generated by AI and may not be accurate. Do not use it for diagnosis or treatment.',
  ClinicalSummaryLabel: 'Clinical Summary',
  ClinicalSummaryLastUpdated: 'Last updated',
};

export type LocaleStringKey = keyof typeof strings;
